/* 🤖 this file was generated by svg-to-ts */
export const siriusQuotes: {
  name: 'quotes';
  data: string;
} = {
  name: 'quotes',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 5.125a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625v.75a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.5 4.5 0 0 0 4.5-4.5v-8.25a1.5 1.5 0 0 0-1.5-1.5H3.75Zm5.625 1.5v6H3.75v-6h5.625ZM14.625 5.125a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625v.75a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.5 4.5 0 0 0 4.5-4.5v-8.25a1.5 1.5 0 0 0-1.5-1.5h-5.625Zm5.625 1.5v6h-5.625v-6h5.625Z" fill="currentColor"/></svg>`
};
